import store from "reducers/store";
import { LOOKUPS } from "./lookups";
import { questionsReceived } from "reducers/questionsSlice";
import { pagesReceived } from "reducers/pagesSlice";
import { lookupsReceived } from "reducers/lookupsSlice";
import { sectionsReceived } from "reducers/sectionsSlice";
import { formulasReceived } from "reducers/formulasSlice";
import { dependencyReceived } from "reducers/dependenciesSlice";
import { formDefinitionEdited } from "reducers/formSlice";
import { globalEdited } from "reducers/global";

const QUESTIONS = [
	{
		id: "newOrSupQ",
		title: "Is this a new request, or a request for supplementary funding on an existing project?",
		inputType: "RadioGroup",
		sectionId: "S2",
		pageId: "P1",
		domain: "requestDetails",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "s2q2",
		sectionId: "S2",
		pageId: "P1",
		title: "What is the project number?",
		inputType: "Text",
		visible: { formulaId: "supformula" },
	},
	{
		id: "FPIMSetupType",
		sectionId: "S3",
		pageId: "P1",
		title: "FPIM Setup Type",
		inputType: "Select",
		domain: "FPIMSetupType",
		dataType: "string",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "contactPerson",
		sectionId: "S3",
		pageId: "P1",
		title: "Contact Person",
		inputType: "Text",
		visible: { formulaId: "isItDevice" },
		validation: [{ type: "mandatory" }],
	},
	{
		id: "deliveryAddress",
		sectionId: "S3",
		pageId: "P1",
		title: "Delivery Address",
		inputType: "Text",
		visible: { formulaId: "isItDevice" },
		validation: [{ type: "mandatory" }],
	},
	{
		id: "capabilityType",
		sectionId: "S4",
		pageId: "P1",
		title: "Will this project provide Te Whatu Ora - Waitematā with a new capability and/or replace an existing item?",
		inputType: "CheckBox",
		domain: "capabilityType",
		validation: [{ type: "mandatory" }],
	},
	// {
	// 	id: "reasonforInvestment",
	// 	sectionId: "sectionNpi",
	// 	pageId: "P1",
	// 	title: "Reason for Investment",
	// 	inputType: "TextArea",
	// 	textAreaLines: 3,
	// 	validation: [{ type: "mandatory" }],
	// },
	{
		id: "riskExistingAssetHeading",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Risk associated with existing asset failing",
		inputType: "Heading",
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "serviceImpact",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Service impact of asset failing",
		description:
			"What is the impact to service delivery should the asset fail (and is not available for a period of 24 hours)?",
		inputType: "Select",
		domain: "serviceImpact",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "patientStaffImpact",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Patient / Staff impact of asset failing",
		description:
			"What is the impact on staff or the patient should the asset fail whilst in use?",
		inputType: "Select",
		domain: "patientStaffImpact",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "likelihoodOfAssetFailing",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Likelihood of asset failing",
		description:
			"What is the likelihood of the asset failing?  This can be based on a number of factors including the asset condition, type of construction or material, the location and operating conditions of the asset.",
		inputType: "Select",
		domain: "likelihoodOfAssetFailing",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "assetCriticality",
		sectionId: "sectionNpi",
		description:
			"No data entry required. This is based on the 3 datafields entered above.",
		pageId: "P1",
		title: "Asset Criticality",
		inputType: "AssetCriticality",
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "overallRiskAssetFailure",
		sectionId: "sectionNpi",
		description:
			"No data entry required. This is based on the 3 datafields entered above.",
		pageId: "P1",
		title: "Overall Risk Associated with Asset Failing",
		inputType: "OverallRiskAssetFailure",
		visible: { formulaId: "isNotReplacement" },
	},

	{
		id: "riskNewAsset",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Risk associated with investment not occuring",
		descripton: "asdfasdf",
		inputType: "Heading",
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "consequence1",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequences (1 of 3)",
		description:
			"What will be the impact of not undertaking the investment?",
		inputType: "Select",
		domain: "consequences",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "weighting1",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequence weighting (1 of 3)",
		inputType: "Select",
		domain: "weighting",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "consequence2",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequences (2 of 3)",
		description:
			"What will be the impact of not undertaking the investment?",
		inputType: "Select",
		domain: "consequences",
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "weighting2",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequence weighting (2 of 3)",
		inputType: "Select",
		domain: "weighting",
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "consequence3",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequences (3 of 3)",
		description:
			"What will be the impact of not undertaking the investment?",
		inputType: "Select",
		domain: "consequences",
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "weighting3",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Consequence weighting (3 of 3)",
		inputType: "Select",
		domain: "weighting",
		visible: { formulaId: "isReplacement" },
	},
	{
		id: "likelihoodOfConsequence",
		sectionId: "sectionNpi",
		pageId: "P1",
		title: "Likelihood of event occurring",
		inputType: "Select",
		domain: "likelihoodOfConsequence",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "overallRiskConsequence",
		sectionId: "sectionNpi",
		description:
			"No data entry required. This is based on the consequences entered above.",
		pageId: "P1",
		title: "Overall Risk Associated with Investment Not Occurring",
		inputType: "OverallRiskConsequences",
		visible: { formulaId: "isNotReplacement" },
	},
	{
		id: "s6q1-2",
		sectionId: "S6",
		pageId: "P1",
		title: "Service Name",
		inputType: "Select",
		domain: "services",
	},
	{
		id: "s6q1",
		sectionId: "S6",
		pageId: "P1",
		title: "Responsibility centre",
		inputType: "TreeSelect",
		domain: "Test",
		staticType: "approvalRc",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "endUserCode",
		sectionId: "S6",
		pageId: "P1",
		title: "End User Code (where item will be delivered to)",
		inputType: "Select",
		domain: "endUserCode",
	},
	{
		id: "s6q2",
		sectionId: "S6",
		pageId: "P1",
		title: "Project end date",
		description: "Not less than 3 months away",
		inputType: "ProjectEndDate",
		dataType: "date",
	},
	{
		id: "s6q3",
		sectionId: "S6",
		pageId: "P1",
		title: "Supporting documentation",
		description:
			"To include any business cases, meeting minutes and any other relevant supporting documentation.</br>NB Quotes should be attached on the following page</br>NB Email (msg) files cannot be uploaded for security reasons",
		inputType: "Attachment",
	},
	{
		id: "projectCode",
		sectionId: "S7",
		pageId: "P1",
		title: "Project Code",
		description: "Admin use only",
		inputType: "Text",
	},
	{
		id: "projectShortName",
		sectionId: "S7",
		pageId: "P1",
		title: "Project Name as it should appear in FPIM",
		description: "Maximum 30 characters, including prefix",
		prefix: "WT-23-",
		inputType: "Text",
		validation: [{ type: "mandatory" }, { type: "maxLength", value: 24 }],
		options: {
			wordCount: { max: 24 },
		},
	},
	{
		id: "projectDescription",
		sectionId: "S7",
		pageId: "P1",
		title: "Project Long Name / Description",
		description: "Maximum 80 characters, including prefix",
		prefix: "WT-23-",
		inputType: "Text",
		validation: [{ type: "mandatory" }, { type: "maxLength", value: 74 }],
		options: {
			wordCount: { max: 74 },
		},
	},
	{
		id: "s7q2",
		sectionId: "S7",
		pageId: "P1",
		title: "Project outline/summary",
		inputType: "TextArea",
		textAreaLines: 3,
		validation: [{ type: "mandatory" }],
	},
	{
		id: "s7q3",
		sectionId: "S7",
		pageId: "P1",
		title: "What is the risk being addressed?",
		inputType: "TextArea",
		textAreaLines: 3,
		validation: [{ type: "mandatory" }],
	},
	{
		id: "s7q4",
		sectionId: "S7",
		pageId: "P1",
		title: "What are the alternatives, including consequences of not doing the project?",
		inputType: "TextArea",
		textAreaLines: 3,
		validation: [{ type: "mandatory" }],
	},
	{
		id: "q1",
		name: "expenditureRequest",
		sectionId: "S8",
		pageId: "P2",
		title: "Details of capital expenditure request",
		inputType: "Table",
		dataType: "string",
		depth: 0,
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "q2",
		name: "item",
		title: "Item description",
		inputType: "Text",
		dataType: "string",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 6 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "q3a",
		name: "majorCategory",
		title: "Major Category",
		inputType: "MajorCategory",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 4 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "q3b",
		name: "minorCategory",
		title: "Minor Category",
		inputType: "MinorCategory",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 5 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "q4",
		name: "currency",
		title: "Currency",
		inputType: "Select",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 2 },
		domain: "currency",
		defaultValue: "NZD",
	},

	{
		id: "quantity",
		name: "quantity",
		title: "Qty.",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 1 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},

	{
		id: "unitPrice",
		name: "unitPrice",
		title: "Unit Price",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 2 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "q7",
		name: "totalCost",
		title: "Total Cost",
		inputType: "NumberDisplay",
		dataType: "currency",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 2 },
		disabled: true,
		defaultValue: {
			formulaId: "formulaId",
		},
	},
	{
		id: "s8q1",
		name: "expenditureAttachments",
		title: "Quote",
		inputType: "Attachment",
		dataType: "miniAttachment",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q1",
		col: { span: 2 },
	},
	{
		id: "q8",
		name: "ongoingCosts",
		sectionId: "S8",
		pageId: "P2",
		title: "Associated additional operating costs, if applicable",
		inputType: "Table",
		depth: 0,
	},
	{
		id: "costType",
		sectionId: "S8",
		pageId: "P2",
		title: "Cost Type",
		inputType: "Select",
		domain: "costType",
		parentQuestionId: "q8",
		col: { span: 12 },
		validation: [
			{
				type: "mandatory",
			},
		],
		options: {
			mode: "tags",
			multiple: false,
		},
	},
	{
		id: "years",
		name: "years",
		title: "No. of Years",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q8",
		col: { span: 3 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "amountPerYear",
		name: "amountPerYear",
		title: "Amount Per Year",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q8",
		col: { span: 3 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},

	{
		id: "totalOngoingCost",
		name: "totalOngoingCost",
		title: "Total",
		inputType: "NumberDisplay",
		dataType: "currency",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q8",
		col: { span: 4 },
		disabled: true,
		defaultValue: {
			formulaId: "ongoingTotal",
		},
	},
	{
		id: "ongoingCostsQuote",
		name: "ongoingCostsQuote",
		title: "Quote",
		inputType: "Attachment",
		dataType: "miniAttachment",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q8",
		col: { span: 2 },
	},
	{
		id: "replacementProject",
		name: "replacementProject",
		title: "Is this project a replacement of an existing asset?",
		inputType: "RadioGroup",
		sectionId: "S8",
		pageId: "P2",
		domain: "YN",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "anyItemReplacement",
		name: "anyItemReplacement",
		title: "Will the replaced asset be decommissioned?",
		inputType: "RadioGroup",
		sectionId: "S8",
		pageId: "P2",
		domain: "YN",
		validation: [{ type: "mandatory" }],
		visible: { formulaId: "replacementProjectFormula" },
	},
	{
		id: "q10",
		name: "replacedItems",
		sectionId: "S8",
		pageId: "P2",
		title: "Provide the details of the items being replaced.",
		inputType: "Table",
		depth: 0,
		visible: { formulaId: "anyItemReplacementFormula" },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "assetDescription",
		name: "assetDescription",
		title: "Asset Description",
		inputType: "Text",
		dataType: "string",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 4 },
		validation: [{ type: "mandatory" }],
	},
	{
		id: "datePurchased",
		name: "datePurchased",
		sectionId: "S8",
		pageId: "P2",
		title: "Date Purchased (if known)",
		inputType: "DatePicker",
		dataType: "date",
		parentQuestionId: "q10",
		col: { span: 3 },
	},
	{
		id: "assetNumber",
		title: "Waitematā (Tag) Asset #",
		inputType: "AutoComplete",
		sectionId: "S8",
		pageId: "P2",
		domain: "asset",
		parentQuestionId: "q10",
		col: { span: 2 },
	},
	{
		id: "serialNumber",
		title: "Serial #",
		inputType: "Text",
		dataType: "string",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 2 },
	},
	{
		id: "farNumber",
		title: "Fixed Asset Reg. #",
		inputType: "Text",
		dataType: "string",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 2 },
	},
	{
		id: "whatHappenToThisAsset",
		name: "whatHappenToThisAsset",
		title: "What will happen to this asset?",
		inputType: "AutoComplete",
		domain: "assetFate",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 5 },
	},

	{
		id: "originalCost",
		name: "originalCost",
		title: "Original Cost",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 3 },
	},
	{
		id: "nbv",
		name: "NBV",
		title: "NBV",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S8",
		pageId: "P2",
		parentQuestionId: "q10",
		col: { span: 3 },
		validation: [{ type: "mandatory" }],
	},
	{
		id: "assetDisposalForm",
		sectionId: "S8",
		pageId: "P2",
		title: "Please attach Asset Disposal Form here<br /><a href='Asset Disposal and Transfer Form (16 Apr-13).doc'>Download Disposal Form Template</a><br /><a href='Multi Asset Disposal Attachment (16 Apr-13).doc'>Download Multi Disposal Form Template</a>",
		inputType: "Attachment",
		visible: { formulaId: "anyItemReplacementFormula" },
	},
	{
		id: "s9q1",
		sectionId: "S9",
		pageId: "P3",
		title: "Please attach the Project Task Structure template here. <a href='Task Breakdown Structure - Template.xlsx'>Download Template</a>",
		inputType: "Attachment",
	},
	{
		id: "receivedPriorApprovalAsset",
		name: "receivedPriorApprovalAsset",
		title: "Have any of the items requested received prior approval as critical clinical items identified for replacement in the annual budget process?",
		description:
			"Note that not all critical items get approved as part of the budget",
		inputType: "RadioGroup",
		sectionId: "S11",
		pageId: "P4",
		domain: "YN",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "q11",
		name: "priorApprovalAsset",
		sectionId: "S11",
		pageId: "P4",
		title: "Provide the details",
		inputType: "Table",
		depth: 0,
		visible: { formulaId: "receivedPriorApprovalAssetFormula" },
		validation: [
			{
				type: "mandatory",
				Value: 0,
			},
		],
	},
	{
		id: "assetTagNumberDescription",
		title: "Asset tag, serial number & description",
		inputType: "AutoComplete",
		sectionId: "S11",
		pageId: "P4",
		domain: "asset",
		parentQuestionId: "q11",
		col: { span: 12 },
		validation: [{ type: "mandatory" }],
	},
	{
		id: "location",
		name: "location",
		title: "Location",
		inputType: "Select",
		sectionId: "S11",
		pageId: "P4",
		parentQuestionId: "q11",
		col: { span: 6 },
		domain: "location",
	},
	{
		id: "priorApprovalAssetAmount",
		name: "priorApprovalAssetAmount",
		title: "Amount",
		inputType: "Text",
		dataType: "currency",
		sectionId: "S11",
		pageId: "P4",
		parentQuestionId: "q11",
		col: { span: 6 },
	},
	{
		id: "willReceiveExternalFunding",
		name: "willReceiveExternalFunding",
		title: "Will the project receive external funding?",
		inputType: "RadioGroup",
		sectionId: "S11",
		pageId: "P4",
		domain: "YN",
		validation: [{ type: "mandatory" }],
	},
	{
		id: "externalFundingDetails",
		name: "externalFundingDetails",
		title: "Please provide details of external funding",
		inputType: "TextArea",
		dataType: "string",
		sectionId: "S11",
		pageId: "P4",
		textAreaLines: 3,
		visible: { formulaId: "willReceiveExternalFundingFormula" },
	},
	{
		id: "externalFundingAttachment",
		name: "externalFundingAttachment",
		sectionId: "S11",
		pageId: "P4",
		title: "Please attach evidence of external funding (email, Board Minutes etc)",
		inputType: "Attachment",
		visible: { formulaId: "willReceiveExternalFundingFormula" },
	},
	{
		id: "fundingSourceTable",
		name: "fundingSource",
		sectionId: "S12",
		pageId: "P4",
		inputType: "Table",
		dataType: "string",
		depth: 0,
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "sourceProjectCode",
		name: "sourceProjectCode",
		title: "Source Project",
		inputType: "Select",
		domain: "budgetCategories",
		sectionId: "S12",
		pageId: "P4",
		parentQuestionId: "fundingSourceTable",
		col: { span: 12 },
	},
	{
		id: "sourceCommitment",
		name: "sourceCommitment",
		title: "Commitment to This Project",
		inputType: "Text",
		dataType: "numeric",
		sectionId: "S12",
		pageId: "P4",
		parentQuestionId: "fundingSourceTable",
		col: { span: 4 },
		validation: [
			{
				type: "mandatory",
			},
		],
	},
	{
		id: "sourceWtProjectCode",
		name: "sourceWtProjectCode",
		title: "WT Project Code",
		inputType: "Text",
		sectionId: "S12",
		pageId: "P4",
		parentQuestionId: "fundingSourceTable",
		col: { span: 8 },
		visible: { formulaId: "isWtProject" },
	},
	{
		id: "fundingHeading",
		sectionId: "S12",
		pageId: "P4",
		title: "Funding Summary",
		inputType: "Heading",
	},
	{
		id: "totalFundingSource",
		sectionId: "S12",
		pageId: "P4",
		title: "Total Funding",
		inputType: "TotalFundingSource",
		dataType: "currency",
		labelColWidth: 16,
		displayMode: "tabular",
	},
	{
		id: "totalFundingDifference",
		description: "Must equal zero",
		sectionId: "S12",
		pageId: "P4",
		title: "Total Shortfall/Surplus",
		inputType: "TotalFundingDifference",
		dataType: "currency",
		labelColWidth: 16,
		displayMode: "tabular",
		validation: [{ type: "numericValue2dp", value: 0.0 }],
	},
];
const SECTIONS = [
	{
		id: "S2",
		pageId: "P1",
		title: "Request details",
	},
	{
		id: "S3",
		pageId: "P1",
		title: "Project type",
		visible: { formulaId: "newrequestformula" },
	},
	{
		id: "S4",
		pageId: "P1",
		title: "Capability type",
	},
	{
		id: "sectionNpi",
		pageId: "P1.5",
		title: "Non-Project Investment",
		visible: { formulaId: "isNotProject" },
	},
	{
		id: "S7",
		pageId: "P1",
		title: "Project brief",
	},

	{
		id: "S6",
		pageId: "P1",
		title: "Service Details",
	},
	{
		id: "S8",
		pageId: "P2",
		title: "Capital Investment - acquisitions and disposals",
		size: "xlarge",
	},
	{
		id: "S9",
		pageId: "P3",
		title: "Project Task Structure in FPIM",
		visible: { formulaId: "isProject" },
	},
	{
		id: "S11",
		pageId: "P4",
		title: "Funding Source - Capex only",
	},
	{
		id: "S12",
		pageId: "P4",
		title: "Funding Source Details - Capex only",
	},
];
const PAGES = [
	{
		id: "P1",
		title: "Overview",
	},

	{
		id: "P2",
		title: "Acquisitions & Disposals",
	},
	{
		id: "P1.5",
		title: "NPI",
	},
	{
		id: "P3",
		title: "FPIM Details",
	},
	{
		id: "P4",
		title: "Funding",
	},
	{
		id: "keyMembers",
		title: "Key Members",
		type: "keyMembers",
	},
	{
		id: "approval",
		title: "Approval",
		type: "capexApproval",
	},
];
const FORMULAS = [
	{
		id: "formulaId",
		text: "unitPrice * quantity",
		dependencies: ["unitPrice", "quantity"],
	},
	{
		id: "ongoingTotal",
		text: "years * amountPerYear",
		dependencies: ["years", "amountPerYear"],
	},
	{
		id: "newrequestformula",
		text: "newOrSupQ = 'newRequest'",
		dependencies: ["newOrSupQ"],
	},
	{
		id: "supformula",
		text: "newOrSupQ = 'supplementaryFundingRequest'",
		dependencies: ["newOrSupQ"],
	},
	{
		id: "anyItemReplacementFormula",
		text: "anyItemReplacement = 'Y'",
		dependencies: ["anyItemReplacement"],
	},
	{
		id: "replacementProjectFormula",
		text: "replacementProject = 'Y'",
		dependencies: ["replacementProject"],
	},
	{
		id: "receivedPriorApprovalAssetFormula",
		text: "receivedPriorApprovalAsset = 'Y'",
		dependencies: ["receivedPriorApprovalAsset"],
	},
	{
		id: "willReceiveExternalFundingFormula",
		text: "willReceiveExternalFunding = 'Y'",
		dependencies: ["willReceiveExternalFunding"],
	},
	{
		id: "isProject",
		text: "OR(FPIMSetupType = 'T-Build Activity-WT';FPIMSetupType = 'T-Seed-WT')",
		dependencies: ["FPIMSetupType"],
	},
	{
		id: "isNotProject",
		text: "NOT(OR(FPIMSetupType = 'T-Build Activity-WT';FPIMSetupType = 'T-Seed-WT'))",
		dependencies: ["FPIMSetupType"],
	},
	{
		id: "isReplacement",
		text: "OR(capabilityType = 'yes'; capabilityType = 'yes,no'; capabilityType = 'no,yes')",
		dependencies: ["capabilityType"],
	},
	{
		id: "isNotReplacement",
		text: "OR(capabilityType = 'no'; capabilityType = 'yes,no'; capabilityType = 'no,yes')",
		dependencies: ["capabilityType"],
	},
	{
		id: "isItDevice",
		text: "FPIMSetupType = 'T-IT Devices-WT'",
		dependencies: ["FPIMSetupType"],
	},
	{
		id: "isWtProject",
		text: "sourceProjectCode = 'WT Project'",
		dependencies: ["sourceProjectCode"],
	},
];
const DEPENDENCIES = [
	{ id: "sourceProjectCode", formulas: ["isWtProject"] },
	{ id: "unitPrice", formulas: ["formulaId"] },
	{ id: "quantity", formulas: ["formulaId"] },
	{ id: "years", formulas: ["ongoingTotal"] },
	{ id: "amountPerYear", formulas: ["ongoingTotal"] },
	{ id: "newOrSupQ", formulas: ["newrequestformula", "supformula"] },
	{ id: "anyItemReplacement", formulas: ["anyItemReplacementFormula"] },
	{ id: "replacementProject", formulas: ["replacementProjectFormula"] },
	{
		id: "receivedPriorApprovalAsset",
		formulas: ["receivedPriorApprovalAssetFormula"],
	},
	{
		id: "willReceiveExternalFunding",
		formulas: ["willReceiveExternalFundingFormula"],
	},
	{
		id: "FPIMSetupType",
		formulas: ["isProject", "isNotProject", "isItDevice"],
	},
	{
		id: "capabilityType",
		formulas: ["isReplacement", "isNotReplacement"],
	},
];

export const dispatchCapexForm = () => {
	store.dispatch(
		formDefinitionEdited({
			id: "e3508ecc-7901-4552-b7df-9734cb97403f",
			appHierarchyId: "4f5f8dc5-f80b-4a0e-ba68-ebf5c748c46f",
			organisationHierarchyId: "A286A211-3873-4F74-AFCA-8F3927986E5F",
			originId: "e3508ecc-7901-4552-b7df-9734cb97403f",
			version: 1,
			name: "CAPEX",
			ownerId: "cb5dbd05-3858-49ee-accf-398ed5d192be",
			isLive: true,
			createBy: "string",
			modifyBy: "string",
			authoriseData: null,
		})
	);
	store.dispatch(questionsReceived(QUESTIONS));
	store.dispatch(pagesReceived(PAGES));
	store.dispatch(lookupsReceived(LOOKUPS));
	store.dispatch(sectionsReceived(SECTIONS));
	store.dispatch(formulasReceived(FORMULAS));
	store.dispatch(dependencyReceived(DEPENDENCIES));
	store.dispatch(globalEdited(app));
};
export const app = {
	screenTitle: "CAPEX Online",
	appType: "capex",
	showFormHeader: true,
	homePath: "/Capex/Dashboard",
	appId: "4F5F8DC5-F80B-4A0E-BA68-EBF5C748C46F",
	formDefinitionId: "E3508ECC-7901-4552-B7DF-9734CB97403F",
	orgRootId: "4E6C1709-FD6A-4C69-A37F-42D6C3E08A36",
	domain: "Test",
	showFooter: true,
	showHeader: true,
};
